import { UseMutationResult, UseQueryResult, useMutation, useQuery } from '@tanstack/react-query'
import {
  confirmReturnManagements,
  getReturnManagements,
  saveReturnManagements,
  searchReturnOrders,
} from './apis'
import {
  ConfirmReturnManagementReq,
  ConfirmReturnManagementRes,
  GetReturnManagementReq,
  OrderSearchItemRes,
  OrderSearchReq,
  ReturnManagementItemRes,
  SaveReturnManagementReq,
  SaveReturnManagementRes,
} from './types'

export const returnManagementQueryKeys = {
  all: ['RETURN_MANAGEMENT'] as const,
  list: (params: GetReturnManagementReq) => [...returnManagementQueryKeys.all, 'LIST', params] as const,
  orderSearch: (params: OrderSearchReq) => [...returnManagementQueryKeys.all, 'ORDER_SEARCH', params] as const,
}

/** 조회 — `enabled=false` 로 두면 필수 필터(화주·반품일자) 미충족 시 요청을 보내지 않는다(피드백 11). */
export const useGetReturnManagements = (
  params: GetReturnManagementReq,
  enabled: boolean,
): UseQueryResult<ApiResponseV2<{ items: ReturnManagementItemRes[] }>, Error> =>
  useQuery({
    queryKey: returnManagementQueryKeys.list(params),
    queryFn: () => getReturnManagements(params),
    enabled,
  })

export const useSaveReturnManagements = (): UseMutationResult<ApiResponseV2<SaveReturnManagementRes>, Error, SaveReturnManagementReq> =>
  useMutation({
    mutationFn: saveReturnManagements,
  })

export const useConfirmReturnManagements = (): UseMutationResult<
  ApiResponseV2<ConfirmReturnManagementRes>,
  Error,
  ConfirmReturnManagementReq
> =>
  useMutation({
    mutationFn: confirmReturnManagements,
  })

/** 주문검색 팝업 — 열렸을 때만 조회한다(`enabled`). */
export const useSearchReturnOrders = (
  params: OrderSearchReq,
  enabled: boolean,
): UseQueryResult<ApiResponseV2<{ items: OrderSearchItemRes[] }>, Error> =>
  useQuery({
    queryKey: returnManagementQueryKeys.orderSearch(params),
    queryFn: () => searchReturnOrders(params),
    enabled,
  })
